import { CarouselPlayEventType, CarouselSlideEventType } from '.';

export class TrackingObjectBuilder {
  trackingObject = {};

  forPageContext({ userType, country, language }: { userType: string; country: string; language: string }) {
    this.trackingObject = {
      userType,
      country,
      language,
    };
    return this;
  }

  forArticleView({ pageSlug, pageCategory }: { pageSlug: string; pageCategory: string }) {
    this.trackingObject = {
      event: 'page',
      eventType: 'view',
      pageSlug: pageSlug.split('?')[0],
      pageCategory,
    };
    return this;
  }

  forFundAccordionOpen({ fundName, fundIsin }: { fundName: string; fundIsin: string }) {
    this.trackingObject = {
      event: 'funds',
      eventType: 'accordionInfo',
      fundName,
      fundIsin,
    };
    return this;
  }

  forFundDetailAccordionOpen({ eventType, fundName, fundIsin }: { eventType: string; fundName: string; fundIsin: string }) {
    this.trackingObject = {
      event: 'funds',
      eventType,
      fundName,
      fundIsin,
    };
    return this;
  }

  forButtonClick({ clickText, clickUrl, parentComponent }: { clickText: string; clickUrl?: string; parentComponent: string }) {
    this.trackingObject = {
      event: 'button',
      eventType: 'click',
      clickText,
      ...(clickUrl && { clickUrl }),
      parentComponent,
    };
    return this;
  }

  forLinkClick({ clickText, clickUrl, parentComponent }: { clickText: string; clickUrl: string; parentComponent: string }) {
    this.trackingObject = {
      event: 'link',
      eventType: 'click',
      clickText,
      clickUrl,
      parentComponent,
    };
    return this;
  }

  forFileDownload({
    clickText,
    fileName,
    parentComponent,
    fundIsin,
    fundName,
  }: {
    clickText: string;
    fileName: string;
    parentComponent: string;
    fundIsin?: string;
    fundName?: string;
  }) {
    this.trackingObject = {
      event: 'file_download',
      eventType: 'download',
      clickText,
      file_name: fileName,
      parentComponent,
      ...(fundIsin && { fundIsin }),
      ...(fundName && { fundName }),
    };
    return this;
  }

  forFieldSubmit({ fieldName, fieldValue, formName }: { formName: string; fieldName: string; fieldValue: string }) {
    this.trackingObject = {
      event: 'form',
      eventType: 'submit',
      formName,
      fieldName,
      fieldValue,
    };
    return this;
  }

  forFormSuccess({ formName }: { formName: string }) {
    this.trackingObject = {
      event: 'form',
      eventType: 'success',
      formName,
    };
    return this;
  }

  forFormError({ errorMessage, formName }: { formName: string; errorMessage: string }) {
    this.trackingObject = {
      event: 'form',
      eventType: 'error',
      formName,
      errorMessage,
    };
    return this;
  }

  forCarouselSlide({ eventType }: { eventType: CarouselSlideEventType }) {
    this.trackingObject = {
      event: 'carousel',
      eventType,
      parentComponent: 'rcm-carousel',
    };
    return this;
  }

  forCarouselPagination() {
    this.trackingObject = {
      event: 'carousel',
      eventType: 'pagination',
      parentComponent: 'rcm-carousel',
    };
    return this;
  }

  forCarouselPlay({ eventType }: { eventType: CarouselPlayEventType }) {
    this.trackingObject = {
      event: 'carousel',
      eventType,
      parentComponent: 'rcm-carousel',
    };
    return this;
  }

  forVideoPlayback({ videoTitle, parentComponent }: { videoTitle: string; parentComponent: string }) {
    this.trackingObject = {
      event: 'video_start',
      video_title: videoTitle,
      eventType: 'play',
      parentComponent,
    };
    return this;
  }

  build() {
    return this.trackingObject;
  }
}
